import benef from '@/styles/benefits/index.module.scss'
import Image from 'next/image'

export const BenefitCard = ({ title, description, list1, list2, list3, image: { name: imgName, url: imgUrl } }) => {
  return (

    <div className={benef.card}>
      <div className={benef.column}>
        <div className={benef.horizontal}>
          <div className={benef.horizontalImage}>
            <div className={benef.circle_image}>
              <Image
                src={imgUrl}
                className={benef.image}
                alt={imgName}
                width={60}
                height={60}
              />
            </div>
          </div>

        </div>
      </div>
      <div className={benef.column3}>
        <p className={benef.textcol1}>{title}</p>
      </div>
      <div className={benef.column2}>
        <ul className={benef.my_list}>
          <li className={benef.list}>{list1}</li>
          <li className={benef.list}>{list2}</li>
          <li className={benef.list}>{list3}</li>

        </ul>
      </div>
    </div>

  )
}
